import type { App } from 'vue'

import { abilitiesPlugin } from '@casl/vue'
import { ability } from './ability'

export default function (app: App) {
  // Usa a instância singleton exportada — será atualizada via API após autenticação
  app.use(abilitiesPlugin, ability, {
    useGlobalProperties: true,
  })
}
